import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./RestaurantHours.css";

const RestaurantHours = ({
  prevStep,
  handleSubmit,
  restaurantData,
  updateRestaurantData,
}) => {
  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());
  const [cutoffTime, setCutoffTime] = useState(new Date());
  const [orderDaysBefore, setOrderDaysBefore] = useState(
    restaurantData.order_cutoff_time || 0
  );

  // List of days to display as checkboxes
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // Handle changes to start/end times, updating restaurantData accordingly
  const handleTimeChange = (field, value) => {
    const updatedTime = value.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    if (field === "start") {
      setStartTime(value);
      updateRestaurantData({
        hours_of_operation: {
          ...restaurantData.hours_of_operation,
          time: `${updatedTime} - ${endTime.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}`,
        },
      });
    } else if (field === "end") {
      setEndTime(value);
      updateRestaurantData({
        hours_of_operation: {
          ...restaurantData.hours_of_operation,
          time: `${startTime.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })} - ${updatedTime}`,
        },
      });
    }
  };

  // Handle day checkbox change
  const handleDayChange = (day, isChecked) => {
    const currentDays = restaurantData.hours_of_operation?.days || [];
    let updatedDays;

    if (isChecked) {
      // Add day if not already in the array
      updatedDays = [...currentDays, day];
    } else {
      // Remove day if it was unchecked
      updatedDays = currentDays.filter((d) => d !== day);
    }

    updateRestaurantData({
      hours_of_operation: {
        ...restaurantData.hours_of_operation,
        days: updatedDays,
      },
    });
  };

  // Handle changes to the "Days Before" cutoff
  const handleDaysBeforeChange = (e) => {
    const days = parseInt(e.target.value, 10) || 0;
    setOrderDaysBefore(days);
    updateRestaurantData({ order_cutoff_time: days });
  };

  return (
    <div className="restaurant-hours">
      <h2>Restaurant Hours</h2>
      
      {/* Operating Days with 7 checkboxes */}
      <label>Operating Days:</label>
      <div className="days-of-week-container">
        {daysOfWeek.map((day) => (
          <div key={day} className="day-checkbox">
            <input
              type="checkbox"
              id={day}
              checked={restaurantData.hours_of_operation?.days?.includes(day)}
              onChange={(e) => handleDayChange(day, e.target.checked)}
            />
            <label htmlFor={day}>{day}</label>
          </div>
        ))}
      </div>

      {/* Start/End Time */}
      <div>
        <label>Start Time:</label>
        <DatePicker
          selected={startTime}
          onChange={(date) => handleTimeChange("start", date)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={30}
          dateFormat="h:mm aa"
        />
        <label>End Time:</label>
        <DatePicker
          selected={endTime}
          onChange={(date) => handleTimeChange("end", date)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={30}
          dateFormat="h:mm aa"
        />
      </div>

      {/* Order Cutoff Time (Time of Day) */}
      <label>Order Cutoff Time (Time of Day):</label>
      <DatePicker
        selected={cutoffTime}
        onChange={(date) => setCutoffTime(date)}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        dateFormat="h:mm aa"
      />

      {/* Order Cutoff Time (Days Before) */}
      <label>Order Cutoff Time (Days Before):</label>
      <input
        type="number"
        value={orderDaysBefore}
        onChange={handleDaysBeforeChange}
        placeholder="e.g., 1 for 1 day before"
      />

      {/* Navigation Buttons */}
      <div className="restaurant-navigation-buttons">
        <button onClick={prevStep} className="prev-btn">
          Back
        </button>
        <button onClick={handleSubmit} className="next-btn">
          Submit
        </button>
      </div>
    </div>
  );
};

export default RestaurantHours;
